import React, { useEffect, useState } from "react";
import Header from "../Header";
import Loader from "../Utils/Loader";

function CarthiFinance(props) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://whatsapp.pcubeweb.com/install-widget/bundle.js?key=65e7e2ad-97b0-4755-9cef-59e23cea9889";
    script.defer = true;
    script.setAttribute("data-active", "");
    script.setAttribute("data-widget-type", "group");
    script.setAttribute("data-person", "f1974065-175b-4348-a567-ab1039b7f21e");
    document.body.appendChild(script);
    setLoading(false);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <div>
      <Header />
      {loading && <Loader />}
      <div
        data-active
        id="whatapp-people-widget-f1974065-175b-4348-a567-ab1039b7f21e"
      ></div>
    </div>
  );
}

export default CarthiFinance;
